import { Typography, Button } from "../../components"
import "./styles.css";

export default function OfferteAanvragen(props) {
    return (
        <div className="container">
            <iframe
                title="Centering Feeding - Offerte aanvragen"
                src="https://form.jotform.com/260205616701043"
                style={{
                width: "100%",
                height: "100vh",
                border: "none"
                }}
                allow="fullscreen; payment"
            ></iframe>
        </div>
  );
}